import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import M from 'materialize-css';
import userMutationHooks from '../../common/mutationHooks/userMutationHooks.ts';

interface IProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  onChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  resendTotp: () => void;
  submitIsPending: boolean;
  originalEmailAddress: string;
  emailAddress: string;
}

const ConfirmationModal = ({
  isOpen,
  setIsOpen,
  resendTotp,
  submitIsPending,
  originalEmailAddress,
  emailAddress,
}: IProps) => {
  const modalRef = useRef<HTMLDivElement>(null);
  const instanceRef = useRef<M.Modal | null>(null);

  const [errorMessage, setErrorMessage] = useState('');
  const [totp, setTotp] = useState('');
  const { mutate: submitTotp, isPending: totpIsPending } =
    userMutationHooks.useUpdateEmailAddress();

  const onChange = ({ target: { value } }: { target: { value: string } }) => {
    setErrorMessage('');
    setTotp(value.toString().toUpperCase());
  };

  const submit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    submitTotp(
      { emailAddress, totp, originalEmailAddress },
      {
        onSuccess: () => {
          setIsOpen(false);
          setTotp('');
        },
      }
    );
  };

  useEffect(() => {
    if (!modalRef.current) return;

    instanceRef.current = M.Modal.init(modalRef.current, {
      onCloseEnd: () => setIsOpen(false),
      dismissible: false,
    });

    return () => {
      instanceRef.current?.destroy();
      instanceRef.current = null;
    };
  }, [setIsOpen]);

  useEffect(() => {
    const instance = instanceRef.current;
    if (!instance) return;

    if (isOpen) {
      instance.open();
    } else {
      instance.close();
    }
  }, [isOpen]);

  return (
    <div ref={modalRef} className="modal">
      <div className="modal-content">
        <div className="card-content" style={{ minHeight: '40vh' }}>
          <div className="row" style={{ marginBottom: '60px' }}>
            <h5
              className="center blue-grey-text text-darken-4"
              style={{
                textDecoration: 'underline',
                marginBottom: '20px',
              }}
            >
              One Time Security Code
            </h5>
            <p className="center">
              We sent a One Time Authentication Code to your new email address.
              Please input that code below to complete the process.
            </p>
            <p className="center">
              If you did not receive a code{' '}
              <a href="/" onClick={resendTotp}>
                Generate Another Code
              </a>
              .
            </p>
          </div>
          <div className="row">
            <div className="row col s10 offset-s1">
              <div className="input-field col s8 offset-s2">
                <input
                  className="center"
                  id="totp"
                  type="text"
                  value={totp}
                  onChange={onChange}
                  style={{ fontSize: '50px' }}
                />
                <label htmlFor="totp">6-Digit Passcode</label>
              </div>
            </div>
          </div>
          <div className="row">
            <button
              className="btn-small blue white-text waves-effect waves-light col s10 offset-s1"
              disabled={submitIsPending || totpIsPending}
              onClick={submit}
            >
              Submit
            </button>
          </div>
          <div className="row">
            <p className="red-text center">{errorMessage}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <a
          className="right"
          style={{ paddingRight: '20px' }}
          href="/"
          onClick={e => {
            e.preventDefault();
            setIsOpen(false);
          }}
        >
          Cancel
        </a>
      </div>
    </div>
  );
};

export default ConfirmationModal;
